const DonutChart = require('./DonutChart');

module.exports = DonutChart;
